<template>
  <div>
    <v-header></v-header>

    <div class="container" style="padding-top: 60px;">
      <div class="banner">
        <img src="../../static/img/banner-4.png" alt="" />

        <h2 class="item-title">
          <span class="eg" style="color:rgba(255,255,255,1);">智慧校园AIOT硬件</span>
           <span class="ch">  伴随着社会的发展，人们对世界一流教育的需求不断提升，
这促使教育园区已经从传统的物理空间逐步成为创新型教
育数字化平台，凡高教育助力您更好地连接家、校、人，
实现物联校园数据实时采集，提升教管教务效率 </span>
        </h2>
      </div>
     
      <div class="features">
        <h2 class="item-title"><span class="eg">智慧校园AloT软硬件一体化解决方案</span> <span class="ch">
                                实现校园万物互联，打破各系统数据孤岛，打造“全数字，全联接，全融合”的智慧校园</span></h2>
        <div class="item-pro">
          <dl>
            <dt>
              <img src="../../static/img/homes-one.png" alt="" style="width: 3.3rem;height: 2.5rem;" />
            </dt>
            <dd>
                <p class="title">闸机</p>
                <p class="titleone"></p>
                <p class="note">支持人脸识别，无感进校/身份识别/通行记录/考勤管理。一人一闸，校园安防重器，将不利校园安全因素堵在校园之外。支持多系统联动，数据共享。</p>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../static/img/homes-two.png" alt="" style="width:2.9rem;height:2.2rem" />
            </dt>
            <dd>
                <p class="title">电子班牌</p>
                <p class="titleone"></p>
                <p class="note">基于智能班牌的走班考勤，引导学生、老师有序走班。智能班牌作为一个多媒体独立发布终端，根据具体需要，既可以用作学校发布教学信息、通知通告、教育宣传，也可以提供互动功能，包括考勤打卡，走班排课、活动查询等。</p>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../static/img/homes-three.png" style="width:2.9rem;height:2.5rem" alt="" />
            </dt>
            <dd>
                <p class="title">人脸识别硬件</p>
                <p class="titleone"></p>
                <p class="note">
                                硬件闸机版/壁挂板/桌面版/立式版最常用于人员通行管理/通行记录/考勤管理，助力校园安防，教务管理。
                            </p>
            </dd>
          </dl>
          <dl>
            <dt>
              <img src="../../static/img/homes-four.png" style="width:2.5rem;height:2.6rem" alt="" />
            </dt>
            <dd>
                <p class="title">高清视频监控</p>
                <p class="titleone"></p>
                <p class="note">高清无感，人脸抓拍。快速无感识别人脸，场馆入场，人员通行，智慧考勤。</p>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .header{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .main{
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix[data-v-6776eb1c]:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }

.item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .item-title .eg {
    margin-bottom: 20px;
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
width:594px;
  }
  .item-title .ch {
    width:594px;
    height:60px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
/* line-height:36px; */
  }

  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button{
    background: transparent;
    border: 1px solid #ff9a00;
    color: #ff9a00
  }

  .banner{
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img{
    width: 100%
  }


 .banner .item-title{
    position: absolute;
    top: -15%;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
    color:rgba(255,255,255,1);
  }
  .banner .item-title .ch{
 
font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
/* line-height:33px; */
margin-top: 20px;
width:574px;
  }
  .banner .item-title .eg{
  width:100%;
margin: 0 auto;
font-size:40px;
font-family:PingFang SC;
font-weight:400;
  }
  .banner .box{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: 43px;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .features{
    padding: 100px 0
  }

  .features .item-pro{
    margin-top: 50px;
    padding: 0 3%;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box
  }
  .features .item-pro dl{
    width: 98%;
    margin: 30px auto;
     box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
     height:520px;
     background:rgba(255,255,255,1);
     display: flex;
     flex-direction: column;
     padding-bottom: 40px;
  }

  
  .features .item-pro dt{
    width: 100%;
    -ms-flex-pack: center;
    justify-content: center;

    height:260px;
    background:rgba(229,246,254,1);
  }
  .features .item-pro dt img{
    text-align: center;
    margin: 35px auto;
    
  }

 
  .features .item-pro dd{
    width: 100%;
    padding-left: 30px;
  }

  .features .item-pro dd .title{
    font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
line-height:27px;
margin-top: 40px;
  }
.features .item-pro dd .titleone{
  width:60px;
height:6px;
background:rgba(42,177,243,1);
margin: 30px 0;
}
  .features .item-pro dd .note{
   font-size:24px;
   width:601px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
margin-top: 15px;

  }


</style>



// WEBPACK FOOTER //
// src/components/homeschool.vue